// Shared JSON-LD structured data (Organization + LocalBusiness) used across
// every page. Previously this exact object was copy-pasted into Home.jsx,
// About.jsx, Services.jsx, Products.jsx, and Contacts.jsx — meaning any
// change to the address, hours, or contact info had to be made in five
// places. Now it's one source of truth; import it wherever it's needed:
//
//   import { structuredData } from '../../data/structuredData'
//
// (adjust the relative path to match where you place this file)

export const structuredData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://rasteghub.co.ke/#organization",
      "name": "RaStegHub",
      "url": "https://rasteghub.co.ke",
      "logo": { "@type": "ImageObject", "url": "https://rasteghub.co.ke/logo192.png" },
      "description": "RaStegHub is a product-driven tech innovation hub based in Nairobi, Kenya.",
      "address": { "@type": "PostalAddress", "addressLocality": "Nairobi", "addressCountry": "KE" },
      "contactPoint": { "@type": "ContactPoint", "email": "hello@rasteghub.co.ke", "contactType": "customer service" },
      "sameAs": ["https://twitter.com/rasteghub", "https://instagram.com/rasteghub", "https://linkedin.com/company/rasteghub"]
    },
    {
      "@type": "LocalBusiness",
      "name": "RaStegHub",
      "url": "https://rasteghub.co.ke",
      "email": "hello@rasteghub.co.ke",
      "address": { "@type": "PostalAddress", "addressLocality": "Nairobi", "addressRegion": "Nairobi County", "addressCountry": "KE" },
      "geo": { "@type": "GeoCoordinates", "latitude": -1.286389, "longitude": 36.817223 },
      "priceRange": "KSh 20,000+",
      "openingHours": "Mo-Fr 09:00-18:00",
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Tech Services",
        "itemListElement": [
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Software Development" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "UI/UX Design" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Social Media Management" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "SEO" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Mentorship & Training" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Ready-Made Solutions" } }
        ]
      }
    }
  ]
}